module.exports = __webpack_public_path__ + "static/media/premier_networking.57d7be41.jpg";